// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productBrandStyles } from "@eisinc/Overrides/Components/ProductBrand";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { printStyles } from "@eisinc/XDL/Utilities";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { css } from "styled-components";

const nameTextStyles = {
    css: css`
        ${wrapInContainerStyles}
    `,
    size: fontConfig.xSmall.size,
    lineHeight: fontConfig.singleLinexSmall.lineHeight,
    weight: fontConfig.weight.medium,
};

productBrandStyles.nameText = {
    ...nameTextStyles,
};

productBrandStyles.nameLink = {
    typographyProps: {
        ...nameTextStyles,
    },
};

productBrandStyles.logoImage = {
    css: css`
        ${printStyles.hideOnPrint}
    `,
};

productBrandStyles.wrapper = {
    css: css`
        display: flex;
    `,
};

productBrandStyles.labelText = {
    size: fontConfig.xSmall.size,
    lineHeight: fontConfig.singleLinexSmall.lineHeight,
    weight: fontConfig.weight.medium,
    css: css`
        word-break: normal;
        letter-spacing: 0;
        margin-right: 4px;
        display: inline-block;
        &:after {
            content: ":";
        }
    `,
};
